import { render, staticRenderFns } from "./moduleEdit.vue?vue&type=template&id=4d40c49c&scoped=true"
import script from "./moduleEdit.vue?vue&type=script&lang=js"
export * from "./moduleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d40c49c",
  null
  
)

export default component.exports